import { useState } from "react";
import { BagArt } from "./BagArt";

export const ProductGallery = ({ f }) => {
  const slides = [
    { key: "bag", label: "Bag" },
    f.fruit && { key: "fruit", label: "Fruit", src: f.fruit },
    { key: "facts", label: "Nutrition", src: "/img/nutrition.jpg" },
  ].filter(Boolean);
  const [idx, setIdx] = useState(0);
  const cur = slides[idx];

  return (
    <div className="relative">
      <div className="relative h-[300px] sm:h-[340px] flex items-center justify-center p-6" style={{ background: `${f.color}26` }}>
        {f.isNew && <span className="absolute top-4 left-4 z-10 rounded-full bg-[#FF5A5F] text-white text-[11px] font-bold uppercase px-3 py-1">New flavour</span>}
        {slides.map((s, i) => (
          <div key={s.key} className={`absolute inset-0 p-6 flex items-center justify-center transition-opacity duration-500 ${i === idx ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
            {s.key === "bag" ? <BagArt f={f} className="h-full max-w-full transition-transform duration-700 ease-out group-hover:-translate-y-2 group-hover:-rotate-3" />
              : <img src={s.src} alt={`${f.name} ${s.label.toLowerCase()}`} loading="lazy" className={`h-full w-full rounded-2xl ${s.key === "facts" ? "object-contain bg-white p-2" : "object-cover"}`} />}
          </div>
        ))}
      </div>
      <div className="flex gap-1.5 px-5 pt-4" role="tablist">
        {slides.map((s, i) => (
          <button key={s.key} data-testid={`gallery-${f.key}-${s.key}`} onClick={() => setIdx(i)} aria-selected={i === idx}
            className={`h-8 px-3 rounded-full text-xs font-bold transition-colors ${i === idx ? "bg-[#1B1530] text-white" : "bg-[#1B1530]/5 hover:bg-[#1B1530]/10"}`}>{s.label}</button>
        ))}
      </div>
      <span className="sr-only">{cur.label}</span>
    </div>
  );
};
